import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import toast from 'react-hot-toast';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';

export default function SectionDialog({ open, setOpen, addSection }) {
  const [question, setQuestion] = React.useState({ label: '' });

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (!question.label) return toast.error('Please fill all required fields');
    const isAdded = addSection(question);

    if (isAdded) {
      setQuestion({ label: '' });
      setOpen(false);
    } else {
      toast.error(`Something wrong happened`);
    }
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} maxWidth='md'>
        <DialogTitle>Add New Section</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>A</DialogContentText> */}

          <TextField
            sx={{ minWidth: 500 }}
            onChange={(e) => setQuestion({ ...question, label: e.currentTarget.value })}
            required
            autoFocus
            margin='dense'
            id='label'
            label='Label'
            type='text'
            fullWidth
            variant='standard'
            value={question.label}
          />
        </DialogContent>
        <Stack direction='row' justifyContent='flex-end' m={2}>
          <Stack direction='row'>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSave}>Save</Button>
          </Stack>
        </Stack>
      </Dialog>
    </div>
  );
}
